
import rules from "../../mixins/rules.mixin.js";

export default {
  name: "AccountForm",

  mixins: [rules],

  methods: {
    normalizarRg(valor) {
      this.account.rg = String(valor || "")
        .toUpperCase()
        .replace(/[^0-9A-Z]/g, "");
    },
  },

  computed: {
    account: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },

  data: () => ({
    indications: [
      "Abordagem na Master",
      "Abordagem na Galeão",
      "Indicação Master",
      "Indicação Telefonia",
      "Indicação Galeão",
      "Reacordo",
      "Panfletagem",
      "Parceiros",
      "Abordagem externa",
      "Eventos externos",
      "Desconto amigo",
      "Conta própria",
      "Outdoors",
      "Taxi/vans",
      "Jornaleiros",
      "Mídias sociais",
      "TMK Ativo",
    ],
  }),

  props: {
    value: Object,
  },
};
